
















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import InformationRow from '@/components/display/information-row.vue';
import Toast from '@/components/display/toast.vue';
import AdrLookup from '@/components/adr-lookup.vue';
import { SiteService } from '@/services/site-service';
import { AddressService } from '@/services/address-service';
import { AddressExtended, SiteExtended } from '@/models/extensions';
import ConfirmModal from '@/components/display/confirm-modal.vue';

@Component({
	components: {
		ConfirmModal,
		InformationRow,
		AdrLookup,
	},
})
export default class SiteAddressSearch extends Vue {
	@Prop({ required: true, type: Object })
	public site!: SiteExtended<AddressExtended>;

	private siteService: SiteService = new SiteService();
	private addressService: AddressService = new AddressService();

	public editing: boolean = false;
	public newAddress: AddressExtended = {};
	public submitting: boolean = false;

	private toast: Toast = new Toast();

	public created(): void {
		this.setAddress();
	}

	private setAddress() {
		this.newAddress = {
			fullAdr: this.site?.address?.fullAdr ?? undefined,
			rawAddress: this.site?.address?.rawAddress ?? null,
		};
	}

	public toggleEditing(): void {
		this.editing = !this.editing;
		if (!this.editing) this.setAddress();
	}

	@Emit('updated')
	public async updateAddress(updateGps: boolean, params?: { modalId: string }): Promise<void> {
		if (!this.newAddress?.rawAddress || this.submitting || !this.site?.id) return;

		this.submitting = true;

		let creating = !this.site.address;
		let response;
		if (!this.site.address) {
			this.site.address = {
				ownerType: 'sites',
				ownerId: this.site.id,
				type: 'street',
				...this.newAddress,
			};
			response = await this.addressService.addAddress(this.site.address);
		} else {
			this.site.address.fullAdr = this.newAddress.fullAdr ?? undefined;
			this.site.address.rawAddress = this.newAddress.rawAddress;
			response = await this.addressService.updateAddress(this.site.address);
		}

		if (response.errorMessage) {
			this.toast.makeToast(
				response.errorMessage,
				`Error ${creating ? 'Setting' : 'Updating'} Site Address`,
				'danger',
				true,
			);
			this.editing = false;
			this.submitting = false;
			if (params) this.$bvModal.hide(params.modalId);
			return;
		}

		const action = creating ? 'set' : 'changed';
		this.toast.makeToast(
			`Address for site ${this.site.name} ${action} to ${this.newAddress.fullAdr}`,
			`Site Address ${action.substring(0, 1).toUpperCase()}${action.substring(1)}`,
			'success',
		);

		if (!this.site.latitude || !this.site.longitude || updateGps) {
			if (!this.site.latitude) this.site.latitude = this.site.address?.latitude;
			if (!this.site.longitude) this.site.longitude = this.site.address?.longitude;

			const updateResponse = await this.siteService.updateSite(this.site, updateGps);
			this.editing = false;
			this.submitting = false;
			if (updateResponse.errorMessage) {
				new Toast().makeToast(
					updateResponse.errorMessage,
					'Error Updating Site Physical Location',
					'danger',
					true,
				);
				return;
			}
		} else {
			this.editing = false;
			this.submitting = false;
		}

		this.editing = false;
		this.submitting = false;

		if (modalId) this.$bvModal.hide(modalId);
	}
}
